import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { ITableServerResponseFilter } from 'src/app/common/interfaces/table/table-server-filter-response.interface';
import { ITableServerFilter } from 'src/app/common/interfaces/table/table-server-filter.inteface';
import { AbstractRtpTransactionService } from '../abstraction/abstract.rtp-transaction.service';
import {
  ICamt035AcwpOption,
  ICamt035AcwpUpdateRequest,
} from '../../interfaces/camt035/camt035-acwp.interface';
import { IWebMessage } from 'src/app/common/interfaces/webmessage-interface';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class RtpTransactionService extends AbstractRtpTransactionService {
  controllerUrl = `/manager/rtp/transactions`;
  urlGetTransactionsList = `${environment.apiUrl}${this.controllerUrl}/grid`;
  urlGetTransactionsExportCSV = `${environment.apiUrl}${this.controllerUrl}/gridExportCSV`;
  urlGetTransactionsExportExcel = `${environment.apiUrl}${this.controllerUrl}/gridExportExcel`;
  urlGetTransactionDetailGrid = `${environment.apiUrl}${this.controllerUrl}/transactionDetail`;
  urlGetRtpReturnPaymentDetailGrid = `${environment.apiUrl}${this.controllerUrl}/transactionReturnDetail`;
  urlGetAcwpStatusList = `${environment.apiUrl}${this.controllerUrl}/camt035AcwpStatusList`;
  urlUpdateAcwpStatus = `${environment.apiUrl}${this.controllerUrl}/camt035AcwpStatus`;

  constructor(private http: HttpClient) {
    super();
  }

  tableFilter(filter: ITableServerFilter): Promise<ITableServerResponseFilter | undefined> {
    return this.http
      .post<ITableServerResponseFilter>(`${this.urlGetTransactionsList}`, filter)
      .toPromise();
  }
  tableExportCSV(filter: ITableServerFilter): Promise<Blob | undefined> {
    return this.http
      .post(`${this.urlGetTransactionsExportCSV}`, filter, {
        responseType: 'blob',
      })
      .toPromise();
  }
  tableExportExcel(filter: ITableServerFilter): Promise<any> {
    return this.http.post(`${this.urlGetTransactionsExportExcel}`, filter).toPromise();
  }

  override getById(messageId: string, type: string): Promise<any> {
    return this.http
      .get<any>(`${this.urlGetTransactionDetailGrid}/${messageId}/${type}`)
      .toPromise();
  }

  override getReturnById(messageId: string, type: string): Promise<any> {
    return this.http
      .get<any>(`${this.urlGetRtpReturnPaymentDetailGrid}/${messageId}/${type}`)
      .toPromise();
  }

  override getAcwpOptions(): Promise<ICamt035AcwpOption[] | undefined> {
    return this.http
      .get<Record<string, string>>(this.urlGetAcwpStatusList)
      .pipe(map(dict => Object.entries(dict).map(([value, label]) => ({ value, label }))))
      .toPromise();
  }

  override updateAcwpStatus(
    paymentInstructionId: string,
    request: ICamt035AcwpUpdateRequest
  ): Promise<IWebMessage | undefined> {
    return this.http
      .post<IWebMessage>(`${this.urlUpdateAcwpStatus}/${paymentInstructionId}`, request)
      .toPromise();
  }
}
